<script lang="ts">
  import type { SvelteComponent } from 'svelte';
  import IconCircleCheck from '~icons/tabler/circle-check';
  import IconX from '~icons/tabler/x';
  import IconAlert from '~icons/tabler/alert-circle';

  export let variant: 'success' | 'warning' | 'danger' | 'light';
  export let icon: typeof SvelteComponent<any> | null = null;
  export let withCloseButton = false;

  let defaultIcons: Partial<Record<typeof variant, typeof SvelteComponent<any>>> = {
    success: IconCircleCheck,
    danger: IconAlert
  };

  let iconToUse = icon ?? defaultIcons[variant] ?? null;
  let ref: HTMLElement;
</script>

<div
  bind:this={ref}
  class="alert d-flex align-items-center gap-2 position-relative"
  class:alert-success={variant === 'success'}
  class:alert-warning={variant === 'warning'}
  class:alert-danger={variant === 'danger'}
  class:alert-light={variant === 'light'}
  role="alert"
>
  {#if iconToUse}
    <svelte:component this={iconToUse} />
  {/if}
  <slot />
  <button class="close text-secondary" aria-label="close" on:click={() => ref.parentNode?.removeChild(ref)}>
    {#if withCloseButton}
      <IconX />
    {/if}
  </button>
</div>

<style>
  .close {
    position: absolute;
    top: 6px;
    right: 8px;
  }
</style>
